<template>
  <div class="project-detail">
    <el-collapse v-model="activeCollapses" class="collapse-main-content">
      <el-collapse-item name="1">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            基本信息
          </div>
        </template>
        <div class="collapse-content">
          <SiruiSearch
            ref="baseInfoFormRef"
            :query="baseInfoData"
            :columns="baseColumns"
            :rules="baseRules"
            :isDisabledForm="disableBaseFormData"
            :isQueryPanel="false"
            @changeMethod="changeMethod"
            labelWidth="120px"
          >
          </SiruiSearch>
        </div>
      </el-collapse-item>
      <el-tabs class="editCooperationTabs" type="border-card" v-model="activeTabName">
        <el-tab-pane label="保管/监管货物" name="freightAndRouteDetailTab">
          <FreightDetailChartTable
            :tableDataList="wmProjectCargos"
            @handleChartChange="handleChartChange"
            :disabled="disableButtons"
            :pageMode="pageMode"
          ></FreightDetailChartTable>
        </el-tab-pane>
        <template v-if="pageMode != 0">
          <el-tab-pane label="关联合同" name="assoCusContractTab">
            <AssociatedContractChartTable
              :tableDataList="associatedData"
              :serviceTypeName="serviceTypeName"
            >
            </AssociatedContractChartTable>
          </el-tab-pane>
          <!-- <el-tab-pane label="审批记录" name="assoAuditionRecordTab">
            <AuditionRecordChartTable></AuditionRecordChartTable>
          </el-tab-pane> -->
        </template>
      </el-tabs>
      <!--附件-->
      <el-collapse-item name="3">
        <!--基本信息-->
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>
            附件上传
          </div>
        </template>
        <div class="cpllapse-content">
          <FileTable
            ref="fileTableRef"
            :attachments="attachments"
            :isShowDownBtn="this.pageMode == 1"
          />
          <!--  :isDisabledDelete="deleteFileDisabled" -->
        </div>
      </el-collapse-item>
    </el-collapse>
    <!-- 底部按钮 fixme需要判断立项状态显示-->
    <footer class="bottomButtons">
      <DetailFooterButtons
        @btnHandler="btnHandler"
        :pageMode="pageMode"
        :projectStatus="getProjectStatusName"
      />
    </footer>
    <ProjectRevokeDialog ref="revokeDialogRef" @handleSure="handleRevoke"></ProjectRevokeDialog>
    <projectToContractDialog
      ref="toContractDialogRef"
      @handleSure="handleConvertDetail"
      :serviceTypeCode="this.baseInfoData.serviceTypeCode"
    ></projectToContractDialog>
  </div>
</template>

<script>
  import { tableColumns } from './columns/tableColumns.js';
  import { baseRules } from './columns/tableRules.js';
  import DetailFooterButtons from './components/DetailFooterButtons.vue';
  import FreightDetailChartTable from './components/freightDetailChartTable/index';
  import AssociatedContractChartTable from './components/associatedContractChartTable/index.vue';
  // import AuditionRecordChartTable from './components/auditionRecordChartTable/index.vue';
  import ProjectRevokeDialog from '../projectList/components/projectRevokeDialog';
  import projectToContractDialog from '../projectList/components/projectToContractDialog';
  import ProjectServiceMixin from '@/pages/park/warehouse/project/mixins/projectServiceMixin';
  import ProjectCommonMixin from '@/pages/park/warehouse/project/mixins/projectCommonMixin';
  import ProjectFormSatusMixin from '@/pages/park/warehouse/project/mixins/projectFormSatusMixin';
  import BASE_API from '@/api/dataBase.js';
  import FileTable from '@/components/business/FileTable/index.vue';
  import PROJECTAPI from '@/api/park/project';
  export default {
    name: 'projectCreates',
    mixins: [ProjectServiceMixin, ProjectCommonMixin, ProjectFormSatusMixin],
    data() {
      return {
        baseRules: baseRules,
        associatedData: [],
        serviceTypeName: '',
        baseInfoData: {
          version: '', //详情页编辑需要的参数
          id: '', //详情页编辑需要的参数
          projectCode: '', //项目编号  详情页编辑需要的参数
          applyDepartmentNo: '',
          applyDepartmentName: '',
          bidTitle: '',
          bidderId: '',
          bidderName: '',
          applyDate: '',
          projectName: '',
          bidTotalAmount: 0,
          projectSourceType: '',
          bidOpeningDate: '',
          bidClosingDate: '',
          linkedCompanyCode: '',
          linkedCompanyName: '',
          customerCodeOne: '',
          customerNameOne: '',
          customerTypeOne: '',
          customerTypeTwo: '',
          customerTypeThree: '',
          customerNatureOne: '',
          customerLegalPersonOne: '',
          customerContactPersonOne: '',
          customerContactPhoneOne: '',
          customerContactEmailOne: '',
          customerPayMethodOne: '',
          customerCodeTwo: '',
          customerNameTwo: '',
          customerNatureTwo: '',
          customerLegalPersonTwo: '',
          customerContactPersonTwo: '',
          customerContactPhoneTwo: '',
          customerContactEmailTwo: '',
          customerPayMethodTwo: '',
          customerCodeThree: '',
          customerNameThree: '',
          customerNatureThree: '',
          customerLegalPersonThree: '',
          customerContactPersonThree: '',
          customerContactPhoneThree: '',
          customerContactEmailThree: '',
          companyCode: '',
          companyName: '',
          departmentCode: '',
          departmentName: '',
          // customerPayMethodThree: '',
          // productType: '',
          // productTypeName: '',
          serviceTypeCode: '',
          serviceTypeName: '',
          projectStartDate: '',
          projectEndDate: '',
          projectProfitModel: '',
          projectProfitDescription: '',
          projectRiskPoints: '',
          riskPreventionMeasures: '',
          projectStatus: '',
          projectNature: '',
          // invalidReason:'',
          createByName: '',
          gmtCreate: null,
          lastModifiedByName: '',
          gmtModified: '',
          projectResponsiblePerson: '', //项目负责人
          projectOverallDescription: '',
        },
        wmProjectCargos: [],
        data: {
          projectStatus: '审批驳回',
        },
        // uploadTableData: [],
        //0代表创建，1代表详情页查看状态，2代表详情页编辑状态
        activeTabName: 'freightAndRouteDetailTab',
        activeCollapses: ['1', '2', '3'],
        pageMode: 0,
        // baseColumns: [],
        departmentList: [],
        companyList: [],
        departmentCode: '',
        companyCode: '',
        origin: '',
        // disableBaseFormData: false,
        // disableButtons: false,
        oneFiledList: [
          'customerCodeOne',
          'customerTypeOne',
          'customerNatureOne',
          'customerLegalPersonOne',
          'customerContactPersonOne',
          'customerContactPhoneOne',
          'customerContactEmailOne',
          'customerPayMethodOne',
        ],
        twoFiledList: [
          'customerCodeTwo',
          'customerTypeTwo',
          'customerNatureTwo',
          'customerLegalPersonTwo',
          'customerContactPersonTwo',
          'customerContactPhoneTwo',
          'customerContactEmailTwo',
          'customerPayMethodTwo',
        ],
        threeFiledList: [
          'customerCodeThree',
          'customerTypeThree',
          'customerNatureThree',
          'customerLegalPersonThree',
          'customerContactPersonThree',
          'customerContactPhoneThree',
          'customerContactEmailThree',
        ],
        visibleField: [
          'customerCodeOne',
          'customerTypeOne',
          'customerNatureOne',
          'customerLegalPersonOne',
          'customerContactPersonOne',
          'customerContactPhoneOne',
          'customerContactEmailOne',
          'customerPayMethodOne',
        ], //需要显示的字段
        hideCustomerTypeOne: true,
      };
    },
    computed: {
      getProjectStatusName() {
        return this.getStatusName(this.baseInfoData.projectStatus);
      },
      disableBaseFormData() {
        return this.pageMode == 1;
      },
      disableButtons() {
        return this.pageMode == 1;
      },
      baseColumns() {
        return tableColumns(this);
      },
    },
    mounted() {
      if (this.$route.query?.pageMode) {
        this.pageMode = Number(this.$route.query?.pageMode);
        this.origin = this.$route.query?.origin;
        if (this.$route.query?.serviceTypeName) {
          this.serviceTypeName = this.$route.query?.serviceTypeName;
          this.getTableData(this.$route.query?.serviceTypeName, this.$route.query?.projectCode);
        }
      }
      // console.log(this.origin,'this.origin');
      this.init();
      this.getDepartment();
      this.getCompany();
      this.getDefault();
      this.departmentCode = this.userInfo.departmentCode;
      this.companyCode = this.userInfo.companyCode;
    },
    methods: {
      getDefault() {
        if (this.pageMode == 0) {
          this.baseInfoData.applyDepartmentName = this.userInfo.departmentName;
          this.baseInfoData.applyDepartmentNo = this.userInfo.departmentCode;
          this.baseInfoData.bidTitle = this.userInfo.companyName;
          this.baseInfoData.companyName = this.userInfo.companyName;
          this.baseInfoData.companyCode = this.userInfo.companyCode;
          this.baseInfoData.departmentCode = this.userInfo.departmentCode;
          this.baseInfoData.departmentName = this.userInfo.departmentName;
          console.log(this.userInfo, 'this.userInfo');
        }
      },
      async getTableData(serviceTypeName, data) {
        if (serviceTypeName == '仓储服务') {
          let res = await this.$axios.post(PROJECTAPI.QUERYWAREHOUSE, { projectCode: data });
          if (res.data.code == 0) {
            this.associatedData = res.data.data;
          }
        } else {
          let res = await this.$axios.post(PROJECTAPI.QUERYSUPERVISE, { projectNo: data });
          if (res.data.code == 0) {
            this.associatedData = res.data.data;
            this.hideCustomerTypeOne = false;
          }
        }
      },
      //获取部门数据
      async getDepartment() {
        const params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: this.userInfo.companyCode,
        };
        const res = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        this.departmentList = res.data.data.personDepartmentInfo?.map((item) => {
          return {
            value: item.personDepartmentCode,
            label: item.personDepartmentName,
          };
        });
        // console.log(this.departmentList,'this.departmentList');
      },
      // 获取公司数据
      async getCompany() {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        if (data.code == 0) {
          // console.log('company', data.data?.personCompanyInfo);
          this.companyList = data.data?.personCompanyInfo;
          this.companyList.map((item) => {
            item.value = item.personCompanyCode;
            item.label = item.personCompanyName;
          });
        }
      },
      translateApplyDepartmentName(val) {
        return this.departmentList.find((item) => item.value == val)?.label;
      },
      translateBidTitle(val) {
        return this.companyList.find((item) => item.value == val)?.label;
      },
      changeMethod({ val, prop }) {
        if (prop == 'projectNature') {
          this.filterFormField(val);
        } else if (prop == 'customerCodeOne') {
          this.baseInfoData.customerCodeOne = val[0].partnerCode;
          this.baseInfoData.customerNameOne = val[0].partnerZhName;
          if (
            this.baseInfoData.customerCodeTwo &&
            val[0].partnerCode == this.baseInfoData.customerCodeTwo
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeOne = null;
            this.baseInfoData.customerNameOne = null;
          } else if (
            this.baseInfoData.customerCodeThree &&
            val[0].partnerCode == this.baseInfoData.customerCodeThree
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeOne = null;
            this.baseInfoData.customerNameOne = null;
          } else {
            this._assignAdditionalInfo(val[0].partnerCode, 'one');
          }
        } else if (prop == 'customerCodeTwo') {
          this.baseInfoData.customerCodeTwo = val[0].partnerCode;
          this.baseInfoData.customerNameTwo = val[0].partnerZhName;
          if (
            this.baseInfoData.customerCodeOne &&
            val[0].partnerCode == this.baseInfoData.customerCodeOne
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeTwo = null;
            this.baseInfoData.customerNameTwo = null;
          } else if (
            this.baseInfoData.customerCodeThree &&
            val[0].partnerCode == this.baseInfoData.customerCodeThree
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeTwo = null;
            this.baseInfoData.customerNameTwo = null;
          } else {
            this._assignAdditionalInfo(val[0].partnerCode, 'two');
          }
        } else if (prop == 'customerCodeThree') {
          this.baseInfoData.customerCodeThree = val[0].partnerCode;
          this.baseInfoData.customerNameThree = val[0].partnerZhName;
          if (
            this.baseInfoData.customerCodeOne &&
            val[0].partnerCode == this.baseInfoData.customerCodeOne
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeThree = null;
            this.baseInfoData.customerNameThree = null;
          } else if (
            this.baseInfoData.customerCodeTwo &&
            val[0].partnerCode == this.baseInfoData.customerCodeTwo
          ) {
            this.$message.error('客户名称不能相同');
            this.baseInfoData.customerCodeThree = null;
            this.baseInfoData.customerNameThree = null;
          } else {
            this._assignAdditionalInfo(val[0].partnerCode, 'three');
          }
        } else if (prop == 'bidderId') {
          this.baseInfoData.bidderId = val[0].id;
          this.baseInfoData.bidderName = val[0].personName;
        } else if (prop == 'linkedCompanyCode') {
          this.baseInfoData.linkedCompanyCode = val[0].partnerCode;
          this.baseInfoData.linkedCompanyName = val[0].partnerZhName;
        } else if (prop == 'applyDepartmentName') {
          this.baseInfoData.applyDepartmentNo = val;
          this.translateApplyDepartmentName(val);
          this.baseInfoData.applyDepartmentName = this.translateApplyDepartmentName(val);
        } else if (prop == 'bidTitle') {
          this.baseInfoData.bidTitle = this.translateBidTitle(val);
        } else if (prop == 'serviceTypeCode') {
          this.$nextTick(() => {
            this.$refs.baseInfoFormRef.clearValidate();
          });
          if (val == 'CC') {
            this.baseInfoData.serviceTypeCode = val;
            this.baseInfoData.serviceTypeName = '仓储服务';
            this.hideCustomerTypeOne = true;
          } else if (val == 'JG') {
            this.baseInfoData.serviceTypeCode = val;
            this.baseInfoData.serviceTypeName = '监管服务';
            this.hideCustomerTypeOne = false;
          }
        } else if (prop == 'customerTypeOne') {
          if (this.baseInfoData.customerTypeTwo && val == this.baseInfoData.customerTypeTwo) {
            this.$message.error('客户类型不能相同');
            this.baseInfoData.customerTypeOne = null;
          } else if (
            this.baseInfoData.customerTypeThree &&
            val == this.baseInfoData.customerTypeThree
          ) {
            this.$message.error('客户类型不能相同');
            this.baseInfoData.customerTypeOne = null;
          }
        } else if (prop == 'customerTypeTwo') {
          if (this.baseInfoData.customerTypeOne && val == this.baseInfoData.customerTypeOne) {
            this.$message.error('客户类型不能相同');
            this.baseInfoData.customerTypeTwo = null;
          } else if (
            this.baseInfoData.customerTypeThree &&
            val == this.baseInfoData.customerTypeThree
          ) {
            this.$message.error('客户类型不能相同');
            this.baseInfoData.customerTypeTwo = null;
          }
        } else if (prop == 'customerTypeThree') {
          if (this.baseInfoData.customerTypeOne && val == this.baseInfoData.customerTypeOne) {
            this.$message.error('客户类型不能相同');
            this.baseInfoData.customerTypeThree = null;
          } else if (
            this.baseInfoData.customerTypeTwo &&
            val == this.baseInfoData.customerTypeTwo
          ) {
            this.$message.error('客户类型不能相同');
            this.baseInfoData.customerTypeThree = null;
          }
        } else if (prop == 'bidOpeningDate') {
          if (this.baseInfoData.bidClosingDate && val > this.baseInfoData.bidClosingDate) {
            this.$message.error('不能晚于截标日期');
            this.baseInfoData.bidOpeningDate = null;
          }
        } else if (prop == 'bidClosingDate') {
          if (this.baseInfoData.bidOpeningDate && val < this.baseInfoData.bidOpeningDate) {
            this.$message.error('不能早于开标日期');
            this.baseInfoData.bidClosingDate = null;
          }
        } else if (prop == 'projectStartDate') {
          if (this.baseInfoData.projectEndDate && val > this.baseInfoData.projectEndDate) {
            this.$message.error('不能晚于项目结束日期');
            this.baseInfoData.projectStartDate = null;
          }
        } else if (prop == 'projectEndDate') {
          if (this.baseInfoData.projectStartDate && val < this.baseInfoData.projectStartDate) {
            this.$message.error('不能早于项目开始日期');
            this.baseInfoData.projectEndDate = null;
          }
        }
      },
      async _assignAdditionalInfo(partnerCode, upPartner) {
        let additionalInfo = await this.getPartnerInfo(partnerCode);
        if (!additionalInfo) {
          return;
        }
        let partnersPersons = additionalInfo.partnersPersons;
        if (upPartner == 'one') {
          this.baseInfoData.customerNatureOne = additionalInfo.enterpriseType;
          this.baseInfoData.customerLegalPersonOne = additionalInfo.legalPerson;
          if (partnersPersons && partnersPersons.length) {
            this.baseInfoData.customerContactPersonOne = partnersPersons[0].contactPersonName;
            this.baseInfoData.customerContactPhoneOne = partnersPersons[0].mobilePhone;
            this.baseInfoData.customerContactEmailOne = partnersPersons[0].email;
          }
        } else if (upPartner == 'two') {
          this.baseInfoData.customerNatureTwo = additionalInfo.enterpriseType;
          this.baseInfoData.customerLegalPersonTwo = additionalInfo.legalPerson;
          if (partnersPersons && partnersPersons.length) {
            this.baseInfoData.customerContactPersonTwo = partnersPersons[0].contactPersonName;
            this.baseInfoData.customerContactPhoneTwo = partnersPersons[0].mobilePhone;
            this.baseInfoData.customerContactEmailTwo = partnersPersons[0].email;
          }
        } else if (upPartner == 'three') {
          this.baseInfoData.customerNatureThree = additionalInfo.enterpriseType;
          this.baseInfoData.customerLegalPersonThree = additionalInfo.legalPerson;
          if (partnersPersons && partnersPersons.length) {
            this.baseInfoData.customerContactPersonThree = partnersPersons[0].contactPersonName;
            this.baseInfoData.customerContactPhoneThree = partnersPersons[0].mobilePhone;
            this.baseInfoData.customerContactEmailThree = partnersPersons[0].email;
          }
        }
      },
      async getPartnerInfo(partnerCode) {
        var { data } = await this.$axios.post('/maindata/partners/getPartnerInfoByCode', {
          partnerCode,
        });
        if (data.code == 0 && data.data) {
          return data.data;
        } else {
          // this.$message({ showClose: true, message: data.msg, type: 'error' });
        }
        return {};
      },
      filterFormField(val) {
        if (val == 'PIBT10') {
          this.visibleField = this.oneFiledList;
          // console.log(this.visibleField);
        } else if (val == 'PIBT11') {
          this.visibleField = [...this.oneFiledList, ...this.twoFiledList];
          // console.log(this.visibleField);
        } else if (val == 'PIBT12') {
          this.visibleField = [...this.oneFiledList, ...this.twoFiledList, ...this.threeFiledList];
          // console.log(this.visibleField);
        }
      },
      async init() {
        // await this.getCommonDicts();
        await this.initDetail();
      },
      async handleRevoke(invalidReason, remarks) {
        await this.revoke(this.baseInfoData.projectCode, invalidReason, remarks);
        this.$router.push({ path: '/park/warehouse/projectList' });
      },
      handleConvertDetail(contractType) {
        this._convert(contractType, this.baseInfoData.projectCode, this.baseInfoData.projectName);
      },
      btnHandler(name, params) {
        switch (name) {
          case 'save':
            //0保存1提交
            this.save(
              this.baseInfoData,
              this.wmProjectCargos,
              params,
              this.getProjectStatusName,
              this.origin
            );
            break;
          case 'edit':
            if (this.getProjectStatusName == '项目执行中') {
              // if (this.shouldInterceptEdit()) {
              this.$message({
                showClose: true,
                message: '由于此项目下已经关联合同，若需要修改项目，则需要停用此项目下的合同！',
                type: 'error',
              });
              return;
              // }
            }
            this.handleSwitchEditMode();
            break;
          case 'view':
            this.handleSwitchEditMode();
            break;
          case 'cancel':
            this.$store
              .dispatch('tagsView/delView', {
                path: '/park/warehouse/' + this.$route.query?.suffix,
                name: this.$route.query?.suffix,
                meta: {
                  keepAlive: false,
                  title: '',
                },
                query: {},
              })
              .then(() => {
                this.$nextTick(() => {
                  this.$router.push({ path: '/park/warehouse/projectList' });
                });
              });
            break;
          case 'revoke':
            this.$refs.revokeDialogRef.openDialog();
            break;
          case 'convert':
            // this.convert(this.baseInfoData.projectCode);
            this.$refs.toContractDialogRef.openDialog();
            break;
          default:
            break;
        }
      },
      //子传父，货物的数据的回调
      handleChartChange(dataList) {
        this.wmProjectCargos = dataList;
      },
      //编辑,查看
      handleSwitchEditMode() {
        this.pageMode = this.pageMode == 1 ? 2 : 1;
        // this.isEdit()
        // this.getProcessedBaseColumns(
        //   this.getStatusName(this.baseInfoData.projectStatus),
        //   this.$route.query?.origin
        // );
      },
    },
    watch: {},
    components: {
      FileTable,
      DetailFooterButtons,
      ProjectRevokeDialog,
      projectToContractDialog,
      FreightDetailChartTable,
      AssociatedContractChartTable,
      // AuditionRecordChartTable,
    },
  };
</script>

<style lang="scss" scoped>
  .btn-group {
    padding: 20px 0px;
    box-sizing: border-box;
  }

  .footer-bottom-list {
    justify-content: center;
    display: flex;
    padding-top: 20px;
  }

  .bottomButtons {
    padding-top: 20px;
    text-align: center;
  }
</style>
